{
  "name": "@homer.api/homer",
  "version": "1.29.1",
  "type": "module",
  "private": false,
  "config": {},
  "main": "./dist/index.js",
  "module": "./src/index.js",
  "exports": {
    ".": "./src/index.js",
    "./package.json": "./package.json"
  },
  "scripts": {},
  "dependencies": {
    "@homer.challenge/turnstile": "*",
    "@homer.core/api": "*",
    "@homer.core/application": "*",
    "@homer.core/client.info": "*",
    "@homer.core/factory": "*",
    "@homer.core/globals": "*",
    "@homer.core/storage.local": "*",
    "@homer.task/json.stringify": "*",
    "@homer.utility/querystring.encode": "*",
    "@homer.utility/validator.isinstanceof": "*",
    "@homer.utility/validator.isobject": "*",
    "@homer.utility/validator.isstring": "*",
    "@unifold/core": "*"
  },
  "devDependencies": {},
  "requires": [],
  "loads": [
    "@apfelkiste/errorhandler",
    "@homer.challenge/recaptcha",
    "@homer.challenge/turnstile",
    "@homer.core/client.hints",
    "@schema/webpageelement.dialog.notification"
  ]
}
